import Tracing from './Tracing.vue';
import TracingList from './TracingList.vue';
export default {
  Tracing,
  TracingList,
};
